<app-switcher
  [firstValue]="directions.RTL"
  [secondValue]="directions.LTR"
  [firstValueLabel]="'RTL'"
  [secondValueLabel]="'LTR'"
  [value]="currentDirection"
  (valueChange)="toggleDirection($event)"
  [vertical]="vertical">
</app-switcher>
